import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Anchor, Text, Title } from "@mantine/core";

import { Card } from "@prostocheck/ui";

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <Card className="mx-auto max-w-md text-center">
      <Text size="sm" fw={600} c="brand.6">
        404
      </Text>
      <Title order={1} size="h3" mt="xs">
        {t("notFound.title")}
      </Title>
      <Text size="sm" c="dimmed" mt="xs">
        {t("notFound.description")}
      </Text>
      <Anchor
        component={Link}
        to="/"
        size="sm"
        fw={500}
        display="inline-block"
        mt="md"
      >
        {t("notFound.back")}
      </Anchor>
    </Card>
  );
};
